import FrontendDeveloperPage from "./FrontendDeveloperPage";

export default function AngularDeveloperPage() {
  return <FrontendDeveloperPage technology="angular" />;
}
